import React from "react";
import {Animated, Easing, ImageBackground, TouchableOpacity, Text, View, Dimensions} from "react-native-web";
import {SafeAreaView} from "react-navigation";
import {Styles, Colors} from "../Styles";
import Button from "../components/Button";
import {AntDesign} from "@expo/vector-icons";
import {Image} from "react-native-elements"
import {calcSize} from "../Helper";
import {Server} from "../App";
import Loading from "./Loading";
import Svg, {Defs, RadialGradient, Rect, Stop} from "react-native-svg";

export default class Home extends React.Component {
	static navigationOptions = {
		title: "Shiro Dashboard"
	};

	static path = "";

	constructor(props) {
		super(props);

		window.localStorage.setItem("user", `{"token":"MzUwODM2MTQ1OTIxMzI3MTE1.Mw1qZ6ozsPhDKCHfqbXb2qrWiQ+yLGv6rfz+HSpj1WOcDftBMlekB3rcp/6Zc6+t","id":"350836145921327115","name":"KuuHaKu","avatar":"https://cdn.discordapp.com/avatars/350836145921327115/0a21892e002631ad384ceb9c05ed64a8.png?size=512","sessionDate":"8/4/2021","premium":true,"badges":["https://cdn.discordapp.com/emojis/771067569490755624.png?v=1","https://cdn.discordapp.com/emojis/%s.png?v=1","https://cdn.discordapp.com/emojis/%s.png?v=1","https://cdn.discordapp.com/emojis/%s.png?v=1","https://cdn.discordapp.com/emojis/%s.png?v=1","https://cdn.discordapp.com/emojis/%s.png?v=1","https://cdn.discordapp.com/emojis/%s.png?v=1"],"waifu":"","credits":75224,"exceed":{"name":"Imanity","ranking":0,"id":0},"profiles":[{"pseudoAvatar":"https://api.personality-database.com/profile_images/22568.png?credit_id=3463","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":23,"rulesSent":true,"xp":49482,"mid":"350836145921327115","bio":"","id":"350836145921327115694293982016176180","lastVoted":1586970982,"profileColor":"#300000","pseudoName":"Riku","sid":"694293982016176180"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":1,"rulesSent":false,"xp":54,"mid":"350836145921327115","bio":"","id":"350836145921327115732300321673576498","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"732300321673576498"},{"bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":3,"rulesSent":false,"xp":480,"mid":"350836145921327115","bio":"","id":"350836145921327115666619034103447642","lastVoted":1586970982,"profileColor":"#300000","pseudoName":"","sid":"666619034103447642"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":7,"rulesSent":true,"xp":4014,"mid":"350836145921327115","bio":"","id":"350836145921327115783673884482076684","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"783673884482076684"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":2,"rulesSent":false,"xp":210,"mid":"350836145921327115","bio":"","id":"350836145921327115444699999520161793","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"444699999520161793"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":3,"rulesSent":false,"xp":840,"mid":"350836145921327115","bio":"","id":"350836145921327115723255217776230420","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"723255217776230420"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":1,"rulesSent":false,"xp":30,"mid":"350836145921327115","bio":"","id":"350836145921327115763775306095788033","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"763775306095788033"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":2,"rulesSent":false,"xp":345,"mid":"350836145921327115","bio":"","id":"350836145921327115444569270106587167","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"444569270106587167"},{"bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":60,"rulesSent":true,"xp":352140,"mid":"350836145921327115","bio":"","id":"350836145921327115421495229594730496","lastVoted":1586970982,"profileColor":"#300000","pseudoName":"","sid":"421495229594730496"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":2,"rulesSent":false,"xp":360,"mid":"350836145921327115","bio":"","id":"350836145921327115726171298044313694","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"726171298044313694"},{"pseudoAvatar":"","bg":"https://i.pinimg.com/originals/39/03/a1/3903a10484c96c19f4a5fcae971682c6.gif","level":79,"rulesSent":true,"xp":618082,"mid":"350836145921327115","bio":"","id":"350836145921327115614904136437334044","lastVoted":0,"profileColor":"#300000","pseudoName":"","sid":"614904136437334044"}],"rank":171,"bonuses":[{"name":"Exceed Vitorioso","id":0,"value":2}],"waifuMult":1.25}`);

		this.resize = () => calcSize(this);
		this.delta = new Animated.Value(0);
		this.float = new Animated.Value(0);

		this.state = {
			linkColor: "#99a8ae",
			vertical: false,
			connected: false,
			loaded: false
		};
	}

	componentDidMount() {
		Server.onopen = () => {
			this.setState({connected: true});
		};
		Server.onclose = () => {
			this.setState({connected: false});
			console.log("Reconectando");
		};
		Dimensions.addEventListener("change", this.resize);
		if (window.localStorage.getItem("user") && window.localStorage.getItem("servers")) {
			window.open(`${window.location.origin}/Dashboard`, "_self");
			return;
		} else {
			this.setState({loaded: true})
		}
		this.rainbowBackground();
		this.floatingImage();
		calcSize(this);
	}

	componentWillUnmount() {
		Dimensions.removeEventListener("change", this.resize)
	}

	rainbowBackground() {
		Animated.timing(this.delta, {
			toValue: 450,
			duration: 75000,
			easing: Easing.linear
		}).start(() => {
			this.delta.setValue(0);
			this.rainbowBackground();
		});
	}

	floatingImage() {
		Animated.sequence([
			Animated.timing(this.float, {
				toValue: 100,
				duration: 4500,
				easing: Easing.inOut(Easing.quad)
			}),
			Animated.timing(this.float, {
				toValue: 0,
				duration: 4500,
				easing: Easing.inOut(Easing.quad)
			})
		]).start(() => {
			this.floatingImage();
		});
	}

	render() {
		if (this.state.loaded) {
			const color = this.delta.interpolate({
				inputRange: [0, 150, 300, 450],
				outputRange: ["rgba(255, 0, 0, 0.3)", "rgba(0, 255, 0, 0.3)", "rgba(0, 0, 255, 0.3)", "rgba(255, 0, 0, 0.3)"]
			});

			const parallax = this.delta.interpolate({
				inputRange: [0, 450],
				outputRange: ["0%", "-100%"]
			});

			const fluctuation = this.float.interpolate({
				inputRange: [0, 100],
				outputRange: ["0vmin", "-5vmin"]
			});

			return (
				<SafeAreaView style={{flex: 1}}>
					<View style={{
						position: "absolute",
						height: "100%",
						width: "100%",
						transform: [{rotateZ: "20deg"}, {scale: 3}]
					}}>
						<Animated.View
							style={{position: "absolute", left: parallax, width: "100vmax", height: "100vmax"}}>
							<ImageBackground source={require("../assets/img/checkered_bg.png")} resizeMode={"contain"}
											 style={[Styles.parallax, {left: "100%"}]}/>
							<ImageBackground source={require("../assets/img/checkered_bg.png")} resizeMode={"contain"}
											 style={[Styles.parallax, {left: "0%"}]}/>
						</Animated.View>
					</View>
					<Animated.View style={[Styles.bg, {backgroundColor: color}]}>
						<View style={{position: "absolute", top: 0, left: 0}}>
							<Svg height={"100vh"} width={"100vw"}>
								<Defs>
									<RadialGradient
										id={"grad"}
										cx={0}
										cy={0}
										rx={1}
										ry={1}
									>
										<Stop offset={0.35} stopColor={"#000"} stopOpacity={1}/>
										<Stop offset={1} stopColor={"#000"} stopOpacity={0.2}/>
									</RadialGradient>
								</Defs>
								<Rect x={0} y={0} width={"200vmax"} height={"400vmin"} fill={"url(#grad)"}/>
							</Svg>
						</View>
						<View style={{
							height: "100%",
							width: "100vw",
							flexDirection: this.state.vertical ? "column" : "row",
							alignItems: "center",
							justifyContent: "center"
						}}>
							<Animated.Image source={require("../assets/img/shiro.png")} resizeMode={"contain"}
											style={[this.state.vertical ? {
												height: "35vmax",
												width: "90vmin"
											} : {
												width: "35vmax",
												height: "90vmin"
											}, {transform: [{translateY: fluctuation}]}]}/>
							<View style={{width: "50vmax", alignItems: "center"}}>
								<View style={{marginBottom: "2vmax"}}>
									<Text style={[Styles.header, Styles.headerShadow]}>Olá, sou Shiro J. Bot!</Text>
									<Text style={[Styles.header, Styles.headerShadow, {position: "absolute"}]}>Olá, sou
										Shiro J. Bot!</Text>
									<Text style={[Styles.header, Styles.headerMask, {position: "absolute"}]}>Olá, sou
										Shiro
										J. Bot!</Text>
									<Text style={[Styles.header, {
										position: "absolute",
										textShadowColor: "#fffa",
										textShadowRadius: "0.5vmax",
										color: "transparent"
									}]}>Olá, sou Shiro J. Bot!</Text>
								</View>
								<View style={[Styles.textBox, {width: "100%"}]}>
									<Text style={[Styles.subheader, Styles.fontShadow, {marginBottom: "1.5vmax"}]}>
										{"Deixe-me adivinhar, você está à procura de um bot completo e interativo? Bem, sua busca acabou!\nEstou aqui para lhe ajudar a tornar seu servidor mais customizável e divertido, com vários jogos e reações para qualquer ocasião!"}
									</Text>
								</View>
								<View style={{flexDirection: "row", marginTop: "1vmax", marginBottom: "1vmax"}}>
									<Button title={"Convide-me!"}
											color={Colors.primary}
											hoverColor={Colors.primaryLighter}
											icon={
												<AntDesign
													name={"pluscircleo"}
													color={Colors.pinkText}
													size={"3vmax"}
												/>
											}
											hoverIcon={
												<AntDesign
													name={"pluscircle"}
													color={Colors.pinkText}
													size={"3vmax"}
												/>
											}
											buttonStyle={[Styles.bigButton, {padding: "2vmax"}]}
											containerStyle={[Styles.boxShadowDown, Styles.bigButton, {margin: "0.5vmax"}]}
											titleStyle={{
												fontFamily: "Doreking",
												color: Colors.pinkText,
												fontSize: "2vmax",
												marginLeft: "1vmax"
											}}
											onPress={() => window.open("https://discordapp.com/api/oauth2/authorize?client_id=572413282653306901&permissions=842394743&scope=bot", "_blank")}
									/>
									<Button title={"Votar!"}
											color={Colors.primary}
											hoverColor={Colors.primaryLighter}
											icon={
												<AntDesign
													name={"staro"}
													color={Colors.pinkText}
													size={"3vmax"}
												/>
											}
											hoverIcon={
												<AntDesign
													name={"star"}
													color={Colors.pinkText}
													size={"3vmax"}
												/>
											}
											buttonStyle={[Styles.bigButton, {padding: "2vmax"}]}
											containerStyle={[Styles.boxShadowDown, Styles.bigButton, {margin: "0.5vmax"}]}
											titleStyle={{
												fontFamily: "Doreking",
												color: Colors.pinkText,
												fontSize: "2vmax",
												marginLeft: "1vmax"
											}}
											onPress={() => window.open("https://top.gg/bot/572413282653306901/vote", "_blank")}
									/>
									<Button title={"Docs!"}
											color={Colors.primary}
											hoverColor={Colors.primaryLighter}
											icon={
												<AntDesign
													name={"infocirlceo"}
													color={Colors.pinkText}
													size={"3vmax"}
												/>
											}
											hoverIcon={
												<AntDesign
													name={"infocirlce"}
													color={Colors.pinkText}
													size={"3vmax"}
												/>
											}
											buttonStyle={[Styles.bigButton, {padding: "2vmax"}]}
											containerStyle={[Styles.boxShadowDown, Styles.bigButton, {margin: "0.5vmax"}]}
											titleStyle={{
												fontFamily: "Doreking",
												color: Colors.pinkText,
												fontSize: "2vmax",
												marginLeft: "1vmax"
											}}
											onPress={() => window.open("https://github.com/OtagamerZ/ShiroJBot", "_blank")}
									/>
								</View>
								<View style={{flexDirection: "row"}}>
									<Image
										source={"https://top.gg/api/widget/status/572413282653306901.svg?noavatar=true"}
										resizeMode={"contain"}
										style={{width: "10vmax", height: "2vmax", margin: "0.5vmax"}}
									/>
									<Image
										source={"https://top.gg/api/widget/servers/572413282653306901.svg?noavatar=true"}
										resizeMode={"contain"}
										style={{width: "10vmax", height: "2vmax", margin: "0.5vmax"}}
									/>
									<Image
										source={"https://top.gg/api/widget/upvotes/572413282653306901.svg?noavatar=true"}
										resizeMode={"contain"}
										style={{width: "10vmax", height: "2vmax", margin: "0.5vmax"}}
									/>
									<Image
										source={"https://top.gg/api/widget/lib/572413282653306901.svg?noavatar=true"}
										resizeMode={"contain"}
										style={{width: "10vmax", height: "2vmax", margin: "0.5vmax"}}
									/>
								</View>
							</View>
						</View>
					</Animated.View>
					<View style={[Styles.footer, {
						position: "absolute",
						backgroundColor: "transparent",
						flexDirection: "row",
						justifyContent: this.state.vertical ? "center" : "right"
					}]}>
						<Button
							color={Colors.primary}
							hoverColor={Colors.primaryLighter}
							icon={
								<AntDesign
									name={"form"}
									color={Colors.pinkText}
									size={"2vmax"}
								/>
							}
							hoverIcon={
								<AntDesign
									name={"form"}
									color={Colors.pinkText}
									size={"2vmax"}
								/>
							}
							title={"Criador de embeds"}
							buttonStyle={[Styles.smallButton, {padding: "0.75vmax"}]}
							containerStyle={[Styles.smallButton, Styles.boxShadowDown, {
								margin: "0.5vmax",
								marginTop: "-1vmax"
							}]}
							titleStyle={{
								fontFamily: "Doreking",
								color: Colors.pinkText,
								fontSize: this.state.vertical ? "2vmax" : "1vmax",
								marginLeft: "0.5vmax"
							}}
							onPress={() => {
								window.open(`${window.location.origin}/EmbedBuilder`, "_self");
							}}
						/>
						<Button
							color={Colors.primary}
							hoverColor={Colors.primaryLighter}
							icon={
								<AntDesign
									name={"wechat"}
									color={Colors.pinkText}
									size={"2vmax"}
								/>
							}
							hoverIcon={
								<AntDesign
									name={"wechat"}
									color={Colors.pinkText}
									size={"2vmax"}
								/>
							}
							title={"Resposta customizada"}
							buttonStyle={[Styles.smallButton, {padding: "0.75vmax"}]}
							containerStyle={[Styles.smallButton, Styles.boxShadowDown, {
								margin: "0.5vmax",
								marginTop: "-1vmax"
							}]}
							titleStyle={{
								fontFamily: "Doreking",
								color: Colors.pinkText,
								fontSize: this.state.vertical ? "2vmax" : "1vmax",
								marginLeft: "0.5vmax"
							}}
							onPress={() => {
								window.open(`${window.location.origin}/CABuilder`, "_self");
							}}
						/>
					</View>
					<View style={Styles.footer}>
						<Text style={Styles.footerText}>
							{"Copyright © 2020 Yago Gimenez (KuuHaKu). Todos os direitos reservados. OtagamerZ, " +
							"Shiro J. Bot e seu código-fonte são de propriedade de Yago Gimenez (KuuHaKu) " +
							"e da equipe OtagamerZ | Imagem criada por "}
							<TouchableOpacity
								style={{color: this.state.linkColor, fontWeight: "bold"}}
								onClick={() => window.open("https://www.deviantart.com/chocogingerfingers", "_blank")}
								onMouseEnter={() => this.setState({linkColor: Colors.pinkText})}
								onMouseLeave={() => this.setState({linkColor: "#99a8ae"})}
							>
								<Text>chocogingerfingers</Text>
							</TouchableOpacity>
						</Text>
					</View>
				</SafeAreaView>
			)
		} else {
			return (
				<SafeAreaView style={{flex: 1}}>
					<Loading/>
				</SafeAreaView>
			);
		}
	}
}
